/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Flex, Link, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
/* Services */

/**
 * Renders Related Tags Component
 * @param {Number} tags
 * @returns {ReactElement} - Related Tags Component
 */
export default function RelatedTags({ tags }) {
  return tags?.length > 0 ? (
    <Box pos="relative" float="left" w="100%" mt="1vw" mb="3vw">
      <Flex flexWrap="wrap" justifyContent="center" maxW="1200px">
        <Text
          fontSize="14px"
          textAlign="left"
          color="#8a8173"
          padding="0.5vw"
          fontFamily="FedraSansStd-medium"
          ml="6px"
          mr="15px"
        >
          Related Tags
        </Text>
        {tags.map((el, i) => {
          return (
            <NextLink href={el?.url} p refetch={false} passHref legacyBehavior>
              <Link>
                <Box
                  key={i}
                  fontFamily="FedraSansStd-book"
                  padding="0.5vw"
                  fontSize="12px"
                  color="#676055"
                  border="1px solid #CF4523"
                  borderRadius="20px"
                  _hover={{
                    bgColor: '#cd6727',
                    color: '#fff',
                    textDecoration: 'none',
                  }}
                  // ml="15px"
                  // mr="15px"
                  // mb="6px"
                  m={{ base: '2vw', sm: '0.25vw' }}
                  cursor="pointer"
                >
                  {el?.tag}
                </Box>
              </Link>
            </NextLink>
          );
        })}
      </Flex>
    </Box>
  ) : null;
}
